export const BASE_URL = 'https://www.social.subercraftex.com'
